export default __webpack_public_path__ + "static/1767-09797019c3a535fa87babac04653d157.gif";